import { render, staticRenderFns } from "./SetupMobile.vue?vue&type=template&id=f512871c&scoped=true&"
import script from "./SetupMobile.vue?vue&type=script&lang=js&"
export * from "./SetupMobile.vue?vue&type=script&lang=js&"
import style0 from "./SetupMobile.vue?vue&type=style&index=0&id=f512871c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f512871c",
  null
  
)

export default component.exports